import axios from 'axios';
import url from './base-url';
import country from '../utils/country';
import state from '../utils/states';

const api = axios.create({
    baseURL: url,
})
function Headers(auth) {
    return {headers:{ 'x-access-token': auth,'Content-Type': 'application/json'}};
}
export const getAddressByUserId = (userId,auth) => api.get(`/settings/warehouses/${userId}`,Headers(auth));
export const getAddressById = (id,auth) => api.get(`/settings/warehouse/${id}`,Headers(auth));
export const createAddressByCompanyId = (payload,auth) => api.post(`/settings/mainAddress`,payload,Headers(auth));
export const getMainAddress = (userId,auth) => api.get(`/settings/mainAddress/${userId}`,Headers(auth));

export const getCountryById = (id) => {
    const result = country.filter(item=> {return item.id === id})
    return result[0];
}

export const getCountryByIso2 = (iso2) => {
    const result = country.filter(item=> {return (item.iso2 === iso2)? item : ''})
    return result[0];
}
export const getStatesByCountryIso2 = (iso2) => {
    const result = state.filter(item=> {return (item.country_code === iso2)? item : ''});
    return result[0];
}

export const getStatesByCountryId = (id) => {
    const result = state.filter(item=> {return (item.country_id === id)? item : ''});
    return result[0];
}
export const getSymbolbyCurrencyName = (name) =>{
    const result = country.filter(item=> {return (item.currency === name)? item : ''});
    if(result){
        return result[0].currency_symbol;
    }
}
const apis = {
    getCountryById,
    getCountryByIso2,
    getStatesByCountryIso2,
    getStatesByCountryId,
    getAddressByUserId,
    createAddressByCompanyId,
    getMainAddress,
    getSymbolbyCurrencyName,
    getAddressById
}
export default apis;